var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M140 20c66.274 0 120 53.726 120 120s-53.726 120-120 120S20 206.274 20 140 73.726 20 140 20m53.485 73.485c-4.686-4.686-12.284-4.686-16.97 0L120 150l-21.515-21.515c-4.686-4.686-12.284-4.686-16.97 0l-8.03 8.03c-4.686 4.686-4.686 12.284 0 16.97l29.544 29.544c9.373 9.373 24.569 9.373 33.942 0l64.544-64.544c4.686-4.686 4.686-12.284 0-16.97z"
})));
export default SvgCheckCircle;